import React, { useState } from "react";
import "./index.css";

export default function MenuTopo({ onAbrirModal }) {
  const [aberto, setAberto] = useState(false);

  const opcoes = [
    { label: "Produtos", key: "produtos" },
    { label: "Vendas", key: "vendas" },
    { label: "Envio de XML", key: "xml" },
    { label: "Relatórios", key: "relatorios" },
    { label: "Configurações", key: "config" },
  ];

  return (
    <div className="menu-topo">
      <button className="menu-btn" onClick={() => setAberto(!aberto)}>
        ☰ Menu
      </button>
      {aberto && (
        <ul className="menu-lista">
          {opcoes.map((o) => (
            <li
              key={o.key}
              onClick={() => {
                onAbrirModal(o.key);
                setAberto(false);
              }}
            >
              {o.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}